<div class="position-relative">
  <!-- Flat Design Header -->
  <div class="flat-header mb-4">
  </div>

  <!-- 3-Column Layout Container -->
  <div class="three-column-container">
    <!-- Column 1: File Upload/Drop -->
    <div class="column file-upload-column">
      <!-- File Drop Zone -->
      <div *ngIf="!isFile" class="flat-drop-zone"
        [ngClass]="isDragOver() ? 'dragover-active': ''"
      >
        <div id="drag-area"
          class="drag-area-content"
          (drop)="dropFile($event)"
          (dragover)="dragOverFile($event)"
          (dragleave)="dragLeaveFile($event)"
          (dragend)="dragEndFile($event)"
        >
          <div class="upload-icon">
            <img src="../../../assets/images/add_new.svg" alt="upload">
          </div>
          <h4>Drop your file here</h4>
          <p>or <button type="button" (click)="browseFile($event)" class="browse-button">Browse Files</button></p>
          <div class="file-formats">
            <span class="format-tag">CSV</span>
            <span class="format-tag">xls</span>
            <span class="format-tag">XLSX</span>
          </div>
          <input (change)="onFileChange($event)" accept=".csv,.xlsx,.xls" type="file" id="file-input" hidden>
        </div>
      </div>

      <!-- File Uploaded State -->
      <div *ngIf="isFile" class="flat-file-state">
        <div class="file-info">
          <div class="file-icon">
            <img src="../../../assets/images/file.svg" alt="file">
          </div>
          <div class="file-details">
            <h4>{{ uploadedFile?.name }}</h4>
            <p>{{ (uploadedFile?.size / 1024).toFixed(1) }} KB</p>
          </div>
          <button (click)="resetFile()" class="remove-btn" title="Remove file">
            <img src="../../../assets/images/remove.svg" alt="remove">
          </button>
        </div>
      </div>


    </div>

    <!-- Column 2: Upload Type & Button -->
    <div class="column upload-config-column">
      <!-- Upload Type Selector -->
      <div class="config-section">
        <label class="config-label">Upload Type</label>
        <div class="flat-selector" (click)="openFileTypeDropdown($event)">
          <div class="selector-content">
            <span class="selected-text">{{ fileType === "" ? 'Select upload type' : fileType }}</span>
            <div class="selector-arrow">
              <img src="../../../assets/images/dropdown.svg" alt="arrow">
            </div>
          </div>
          
          <div id="file-type-dropdown" class="flat-dropdown">
            <div class="dropdown-item" (click)="onFileTypeChange('location')">
              <div class="item-icon">
                <img src="../../../assets/images/storelist/stores.svg" alt="location">
              </div>
              <span>Location</span>
            </div>
            <div class="dropdown-item" (click)="onFileTypeChange('warehouse')">
              <div class="item-icon">
                <img src="../../../assets/images/storelist/warehouse.svg" alt="warehouse">
              </div>
              <span>Warehouse</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Upload Button -->
      <div class="upload-button-section">
        <button 
          [disabled]="!(isFile && fileType !== '')" 
          [class.disabled]="!(isFile && fileType !== '')"
          class="flat-upload-btn" 
          type="button" 
          (click)="onSubmit()"
        >
          <img src="../../../assets/images/add_new.svg" alt="upload">
          Upload Stock File
        </button>
      </div>
      
      <!-- File Size Requirement -->
      <div class="file-size-requirement">
        <p>Maximum file size: 10MB</p>
      </div>

      
    </div>

    <!-- Column 3: Template Downloads -->
    <div class="column template-column">
      <div class="template-section">
        <p class="template-description">Get the correct format for your data upload</p>
        <div class="template-buttons">
          <button class="flat-template-btn location-btn" type="button" (click)="downloadTemplateFile($event, 'location')">
            <div class="template-icon">
              <img src="../../../assets/images/storelist/stores.svg" alt="location">
            </div>
            <div class="template-info">
              <h5>Location Template</h5>
              <span>Download CSV template for location data</span>
            </div>
          </button>
          <button class="flat-template-btn warehouse-btn" type="button" (click)="downloadTemplateFile($event, 'warehouse')">
            <div class="template-icon">
              <img src="../../../assets/images/storelist/warehouse.svg" alt="warehouse">
            </div>
            <div class="template-info">
              <h5>Warehouse Template</h5>
              <span>Download CSV template for warehouse data</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <div class="summary-section">
    <div class="summary-header">
      <div class="summary-title">
      </div>
      <div class="summary-tabs">
        <div class="tab-switcher">
          <button 
            class="tab-button" 
            [class.active]="activeTab === 'warehouse'" 
            (click)="setActiveTab('warehouse')" 
            type="button">
            <div class="tab-content">
              <div class="tab-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9,22 9,12 15,12 15,22"></polyline>
                </svg>
              </div>
              <div class="tab-text">
                <span class="tab-label">Warehouse</span>
                <span class="tab-description">Bulk upload records</span>
              </div>
            </div>
          </button>
          <button 
            class="tab-button" 
            [class.active]="activeTab === 'location'" 
            (click)="setActiveTab('location')" 
            type="button">
            <div class="tab-content">
              <div class="tab-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div class="tab-text">
                <span class="tab-label">Location</span>
                <span class="tab-description">Location-based records</span>
              </div>
            </div>
          </button>
        </div>
      </div>
      
      <!-- Search Controls -->
      <div class="search-controls">
        <div class="upload-info">
          <h3 class="upload-count">Total Uploads: {{ uploadedSummary?.length }}</h3>
          <div class="printer-status">
            <img *ngIf="isPrinterConnected" class="printer-icon" src="../../../assets/images/storelist/connectIcon.svg">
            <img *ngIf="!isPrinterConnected" class="printer-icon" src="../../../assets/images/storelist/disconnected.svg">
            <span *ngIf="isPrinterConnected" class="printer-text">Connected to Printer App</span>
            <span *ngIf="!isPrinterConnected" class="printer-text disconnected">Disconnected to the Printer App</span>
            <img (click)="connectToPrinter()" [ngClass]="isPrinterLoader ? 'printer-loader' : ''" class="reload-icon" src="../../../assets/images/storelist/reload.svg">
          </div>
        </div>
        <form class="search-block">
            <div class="search-input">
                <input type="text" name="search" placeholder="Search by Batch No, Product Name, Display ID, RFID">
            </div>
            <button type="submit" class="icon-btn">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                </svg>
            </button>
        </form>
        <button type="button" class="reset-btn">
            Reset
        </button>
      </div>
      
      <!-- Accordion Menu -->
      <div class="accordion-container">
        <ng-template [ngIf]="isFilterResult">
          <div class="modern-accordion">
                  <ng-template ngFor let-item [ngForOf]="uploadedSummary">
                    <div class="accordion-item" [class.expanded]="item.expanded">
                      <!-- Level 1: Upload Summary -->
                      <div class="accordion-header">
                        <div class="accordion-content">
                          <div class="accordion-icon" (click)="toggleAccordion($event, 'level1', item.id)">
                            <svg class="accordion-arrow" [class.rotated]="item.expanded" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                              <polyline points="6,9 12,15 18,9"></polyline>
                            </svg>
                          </div>
                          <div class="accordion-info" (click)="openNextLevel($event, 'level1', item.id)">
                            <div class="accordion-title">
                              <span class="upload-date">{{timestampFormat(item.uploaded_at, "DD/MM/YYYY")}}</span>
                              <span class="implant-count">{{ item.implant_count }} Implants</span>
                            </div>
                            <div class="accordion-subtitle">
                              Uploaded by {{ item.uploaded_by }} at {{timestampFormat(item.uploaded_at, "h:mm:ss")}}
                            </div>
                          </div>
                          <div class="accordion-actions">
                            <button class="action-btn download-btn" type="button" (click)="downloadTemplateFile($event, 'store')">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7,10 12,15 17,10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                              </svg>
                              Download
                            </button>
                            <button class="action-btn print-btn {{ !this.isPrinterConnected ? 'disabled' : '' }}" type="button" (click)="this.doPrintAll($event, item)">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6,9 6,2 18,2 18,9"></polyline>
                                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                                <rect x="6" y="14" width="12" height="8"></rect>
                              </svg>
                              Print All
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- Level 2: Implants -->
                      <div class="accordion-body" [class.show]="item.expanded">
                        <div class="implants-container">
                          <ng-template ngFor let-implant [ngForOf]="item.implants">
                            <div class="implant-item" [class.expanded]="implant.expanded">
                              <div class="implant-header">
                                <div class="implant-content">
                                  <div class="implant-icon" (click)="toggleAccordion($event, 'level2', implant.id)">
                                    <svg class="implant-arrow" [class.rotated]="implant.expanded" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <polyline points="6,9 12,15 18,9"></polyline>
                                    </svg>
                                  </div>
                                  <div class="implant-info" (click)="openNextLevel($event, 'level2', implant.id)">
                                    <div class="implant-name">{{ implant.product_name }}</div>
                                    <div class="implant-details">
                                      <span class="detail-item">Batch: {{ implant.batch_no }}</span>
                                      <span class="detail-item">Expiry: {{ implant.expiry_date }}</span>
                                      <span class="detail-item">Code: {{ implant.product_code }}</span>
                                      <span class="detail-item">Qty: {{ implant.quantity }}</span>
                                    </div>
                                  </div>
                                  <div class="implant-status">
                                    <span class="status-badge" [ngClass]="statusColor(implant.status)">{{ implant.status }}</span>
                                  </div>
                                  <div class="implant-actions">
                                    <button class="action-btn print-btn {{ !this.isPrinterConnected ? 'disabled' : '' }}" type="button" (click)="this.doPrintAll($event, item, implant.id)">
                                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <polyline points="6,9 6,2 18,2 18,9"></polyline>
                                        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                                        <rect x="6" y="14" width="12" height="8"></rect>
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- Level 3: Stocks/RFID -->
                              <div class="stocks-container" [class.show]="implant.expanded">
                                <div class="stocks-header">
                                  <h4 class="stocks-title">Individual Stocks</h4>
                                </div>
                                <div class="stocks-list">
                                  <div class="stock-item" *ngFor="let stock of implant.stocks">
                                    <div class="stock-content">
                                      <div class="stock-info">
                                        <div class="stock-rfid">{{ stock.rfid }}</div>
                                        <div class="stock-details">
                                          <span class="stock-display-id">Display ID: {{ stock.display_id ? stock.display_id : '-' }}</span>
                                        </div>
                                      </div>
                                      <div class="stock-status">
                                        <span class="status-badge" [ngClass]="statusColor(stock.status)">{{ stock.status }}</span>
                                      </div>
                                      <div class="stock-actions">
                                        <button class="action-btn print-btn {{ !this.isPrinterConnected ? 'disabled' : '' }}" type="button" (click)="this.doPrintAll($event, item, implant.id, stock.id)">
                                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <polyline points="6,9 6,2 18,2 18,9"></polyline>
                                            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                                            <rect x="6" y="14" width="12" height="8"></rect>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </ng-template>
            </div>
      </div>
    </div>
    
    <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" [class.show]="activeTab === 'warehouse'" [class.active]="activeTab === 'warehouse'" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
          <div class="table-container">
          </div>
        </div>
        <div class="tab-pane fade show" [class.show]="activeTab === 'location'" [class.active]="activeTab === 'location'"  id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
          <div>
            <div class="mb-3">
              <h2 class="text-heading-3 text-start">Upload summary</h2>
            </div>

            <div class="table-container">
              <div *ngIf="isUploadedSummary" class="table-wrapper table-responsive">
                  <table class="table">
                      <thead>
                          <tr class="position-relative">
                              <th class="" style="width: 40%;" scope="col">Uploaded By</th>
                              <th class="" style="width: 30%;" scope="col">
                                Uploaded Date
                                <span (click)="uploadedAtSort()">
                                  <img class="sort-img" src="../../../assets/images/table/sort.png" alt="">
                                </span>
                              </th>
                              <th class="" style="width: 30%;" scope="col"></th>
                          </tr>
                      </thead>
                      <tbody *ngIf="isFilterResult">
                          <tr class="align-middle" *ngFor="let item of uploadedSummary">
                              <td><div class="text-para">{{ item.uploaded_by }}</div></td>
                              <td><div class="text-para">{{ timestampFormat(item.uploaded_at, "DD/MM/YYYY, h:mm:ss") }}</div></td>
                              <td class="d-flex justify-content-end">
                                <button class="primary-btn text-button px-5 p-1" type="button" (click)="downloadUploadedRecords(item.id, item.uploaded_for)">
                                  <i class="file-download-icon">
                                    <img src="../../../assets/images/storelist/downloadIcon.svg">
                                  </i>
                                  Download
                                </button>
                              </td>
                          </tr>
                      </tbody>
                      <tbody *ngIf="!isFilterResult">
                          <td colspan="6">
                              <div class="p-3 no-record text-center flex-container flex-column justify-content-center">
                                  <img src="../../../../assets/images/table/filter_empty_screen.svg" alt="" srcset="">
                                  <h2 class="header-2 mb-2">No records were found matching your search</h2>
                              </div>
                          </td>
                      </tbody>
                  </table>
              </div>

              <div class="" *ngIf="totalPages > 1 && isUploadedSummary">
                  <app-pagination [totalPages]="totalPages" (queryPage)="getQueryPage($event)"></app-pagination>
              </div>
          </div>
          <div *ngIf="!isUploadedSummary" class="p-3 m-3 text-center flex-container flex-column justify-content-center">
              <img src="../../../../assets/images/table/empty_cabinet_summary.svg" alt="" srcset="">
              <h2 class="header-2 mb-2">No records available to view</h2>
          </div>
          </div>
        </div>
      </div>
    </div>
  
  <div id="warning-toast" class="d-flex gap-1 align-items-center warning-toast position-absolute bg-dark p-2">
    <img *ngIf="statusType === 'error'" src="../../../assets/images/warning-error.svg" alt="" srcset="">
    <img *ngIf="statusType === 'success'" src="../../../assets/images/check mark-circle.svg" alt="" srcset="">
    <p class="text-para text-white">{{ statusMessage }}</p>
  </div>
